<!-- <div class="mt-5 action-container">
<div class="uw-heading">
  <div>
    {{ "my_campaign.title" | translate }}
  </div>
</div>
<uw-button
  [isMediumSize]="true"
  *ngIf="this.showButton$ | async as currentCampaign"
  (click)="back()"
  [customStyle]="'margin-bottom: 10px;'"
  btnLabel="button.back"
></uw-button>
</div> -->

<div class="d-flex">

  @if (sideImgSrc) {
    <img class="d-none d-md-block" width="57%" alt="{{sideImageAlt}}" src="{{sideImgSrc}}" />
  } @else {
    <img class="d-none d-md-block" width="57%" alt="My Campaign Side Image" src="assets/images/Layer_1.png" />
  }

  <div class="my-campaign-container text-center">
    @if (donateButtonLable$ | async; as label) {
      <uw-button
        (click)="onDonateNow()"
      [customStyle]="
        'margin-bottom: 10px; overflow-wrap: break-word; height: unset!important; min-height:63px;'
      "
        [tooltipText]="label.tooltipText"
        [btnLabel]="label.donateButtonLabel"
      ></uw-button>
    }

    @if (myCampaignDetails$ | async; as myCampaignDetails) {
      <!--Thermometer stats-->
      @if (myCampaignDetails.isThermometerVisible) {
        <div class="mt-2">
          <div class="mb-3" style="font-size: 20px; line-height: 1.6rem;">
            {{ "my_campaign.thermometer_title" | translate }}
          </div>
          @if (myCampaignDetails.isParticipationThermometerVisible) {
            <div
              class="mt-2"
              >
              <span> {{ "my_campaign.participation_msg" | translate }} </span>
              <span> {{ myCampaignDetails.participationPercentage }} %</span>
              <uw-progress-bar [customNgStyle]="{'width': myCampaignDetails.participationPercentageProgressBarValue}">
                <span style="color:white">{{myCampaignDetails.participationPercentage}} %</span>
              </uw-progress-bar>
            </div>
          }
          @if (myCampaignDetails.isPledgeThermometerVisible) {
            <div class="mt-3">
              <span>{{ "my_campaign.dollars_msg" | translate }} </span>
              @if (!myCampaignDetails.displayPledgeAmount) {
                <span>
                  {{ myCampaignDetails.pledgePercent }} %</span
                  >
                }
                @if (myCampaignDetails.displayPledgeAmount) {
                  <span>
                    {{
                    myCampaignDetails.pledgeAmount
                    | currency : "" : "symbol-narrow" : "1.2-2" : currentLanguage
                    }}</span
                    >
                    <span>
                      / {{ "my_campaign.goal" | translate }}
                      {{
                      myCampaignDetails.curCampaignAmountGoal
                      | currency : "" : "symbol-narrow" : "1.2-2" : currentLanguage
                      }}</span
                      >
                    }
                    <uw-progress-bar [customNgStyle]="{'width': myCampaignDetails.pledgePercentProgressBarValue}">
                      <span style="color:white">{{myCampaignDetails.pledgePercent}} %</span>
                    </uw-progress-bar>
                  </div>
                }
                @if (myCampaignDetails.isUWThermometerVisible) {
                  <div class="mt-2">
                    <span>{{ "my_campaign.money_raised_uw_msg" | translate }} </span>
                    @if (!myCampaignDetails.displayUwPledgeAmount) {
                      <span>
                        {{ myCampaignDetails.uwPledgePercent }} %</span
                        >
                      }
                      @if (myCampaignDetails.displayUwPledgeAmount) {
                        <span>
                          {{
                          myCampaignDetails.uwPledgeAmount
                          | currency : "" : "symbol-narrow" : "1.2-2" : currentLanguage
                          }}</span
                          >
                          <span>
                            / {{ "my_campaign.goal" | translate }}
                            {{
                            myCampaignDetails.uwAmountGoal
                            | currency : "" : "symbol-narrow" : "1.2-2" : currentLanguage
                            }}</span
                            >
                          }
                          <uw-progress-bar [customNgStyle]="{'width': myCampaignDetails.uwPledgePercentProgressBarValue}">
                            <span style="color:white">{{myCampaignDetails.uwPledgePercent}} %</span>
                          </uw-progress-bar>
                        </div>
                      }
                    </div>
                  }
                  <!--Group Thermometer stats-->
                  @if (
                    myCampaignDetails.isGroupThermometerVisible &&
                    myCampaignDetails.groupDetails &&
                    myCampaignDetails.groupDetails.length > 0
                    ) {
                    <div
                      class="mt-4 w-100"
                      >
                      @if (myCampaignDetails.isThermometerVisible) {
                        <hr class="my-4" />
                      }
                      <h1>
                        {{ campaign?.campaignName }}
                      </h1>
                      <div>
                        {{ "my_campaign.group_thermometer_subtitle" | translate }}
                        @for (unitedway of myCampaignDetails.groupDetails; track unitedway) {
                          <div
                            class="d-flex flex-column mt-3"
                            >
                            <div class="pt-3">
                              {{ unitedway.city }}
                            </div>
                            <div class="w-100">
                              <uw-progress-bar [customNgStyle]="{'width': unitedway.percentageProgressBarValue}">
                                <span style="color:white">{{unitedway.percentage}} %</span>
                              </uw-progress-bar>
                            </div>
                          </div>
                        }
                        <div class="mt-3">
                          {{ "my_campaign.participation_msg" | translate }}
                        </div>
                      </div>
                    </div>
                  }
                }
              </div>
            </div>
